// Language settings shared by the server layout, client components and node:test.
// Keep this file free of runtime imports: tests load it directly with Node's type stripping.
import type en from './messages/en.json'

/** The languages the UI can be shown in. English is the default and the fallback. */
export const LOCALES = ['en', 'es'] as const
export type Locale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'en'

/** Each language's name in that language, so the switcher reads right whatever the current language is. */
export const LOCALE_NAMES: Record<Locale, string> = { en: 'English', es: 'Español' }

/** The cookie that remembers the chosen language; read on the server by getLocale(). */
export const LOCALE_COOKIE = 'NEXT_LOCALE'
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

/**
 * use-intl's formatter isn't used (numbers and dates keep their existing formatting, D3); set only so use-intl
 * doesn't log ENVIRONMENT_FALLBACK. Choose a real zone if useFormatter is ever adopted.
 */
export const TIME_ZONE = 'UTC'

/** Every message file has English's shape. */
export type AppMessages = typeof en

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

/** The `document.cookie` assignment that stores `locale`, scoped to the app's base path. */
export function localeCookie(locale: Locale, basePath = ''): string {
  const path = basePath && basePath !== '/' ? basePath : '/'
  return `${LOCALE_COOKIE}=${locale}; Path=${path}; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax`
}
